import React, { useEffect, useState } from "react";
import CommonList from "../crud/CommonList";
import { apiCallResponse } from "src/_apiConfig/apiCall";
import { TableHeader } from "../common/Table/TableHeaderLabel";
import {
  CommonSearch,
  SCInput,
  updateSearchStatus,
} from "../common/CommonSearch";
import Auth from "src/auth";
import {
  FilterEqual,
  FilterContainsInsensitive,
} from "../common/FilterCondition";
// import usersData from "../users/UsersData";
const LotDetails = () => {
  const [usersData, setuserData] = useState();
  const [loading, setloading] = useState(false);
  const [pageLimit, setpageLimit] = useState(0);
  const [disabledprev, setdisabledprev] = useState(false);
  const [disablednext, setdisablednext] = useState(false);
  const [textField, settextField] = useState("emailId");
  const [order, setorder] = useState("asc");
  const [itemPerPage, setItemPerPage] = useState(10);
  const [orderClick, setOrderClick] = useState(true);

  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const { authenticated } = Auth();

  const defaultCommonSearchModel = {
    collectionSeason:  new Date().getFullYear().toString(),
    tenderNo: "",
    companyName: "",
    emailAddress: "",
    lotNo: "",
    socity: "",
  };
  const [search, setSearch] = useState(defaultCommonSearchModel);
  useEffect(() => {
    setloading(true);
    reset();
    getPageCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getLotDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit, textField, orderClick, itemPerPage]);

  useEffect(() => {
    if (isSearch) {
      getPageCount();
      getLotDetails();
      setIsClear(false);
      setIsSearch(false);
      // reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  //table header Click manage
  const thClick = (ev, getTextField) => {
    ev.preventDefault();
    setOrderClick(!orderClick);
    if (textField !== getTextField) {
      setorder("asc");
    } else {
      !orderClick ? setorder("asc") : setorder("desc");
    }
    reset();
    settextField(getTextField);
  };
  //table Header Set
  const tableHeaderSet = (labelValue, getTextField) => {
    return TableHeader(labelValue, getTextField, thClick, textField, order);
  };
  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    if (isRecordGet === false) {
      setPageCount(0);
      paggingDisabled();
    } else {
      setPageCount(parseInt(totalRecord));
      paggingDisabled(
        pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
        pageLimit === 0
      );
    }
  };

  const fields = [
    {
      key: "emailId",
      label: tableHeaderSet("Email Address", "emailId"),
    },
    {
      key: "companyName",
      label: tableHeaderSet("Company Name", "companyName"),
    },
    {
      key: "lotNo",
      label: tableHeaderSet("Lot Number", "lotNo"),
    },
    {
      key: "tenderNo",
      label: tableHeaderSet("Tender", "tenderNo"),
    },
    {
      key: "quantity",
      label: tableHeaderSet("Quantity", "quantity"),
    },
    {
      key: "purchaseRate",
      label: tableHeaderSet("Purchase Rate per S.B.", "purchaseRate"),
    },
    {
      key: "purchasePrice",
      label: tableHeaderSet("Purchase Price (In Rs.)", "purchasePrice"),
    },
    {
      key: "socity",
      label: tableHeaderSet("Society", "socity"),
    },

    {
      key: "show_details",
      label: "View",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    {
      key: "viewSanctionLetter",
      label: "View Sanction",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },
    // {
    //   key: "viewAgreementLetter",
    //   label: "View Agreement",
    //   _style: { width: "1%" },
    //   sorter: false,
    //   filter: false,
    // },
    {
      key: "viewTermiationLetter",
      label: "View Termination Letter",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
    },

    {
      key: "collectionSeason",
      label: "Collection Season",
      _style: { width: "1%" },
      sorter: false,
      filter: false,
      _classes: "d-none",
    },
  ];
  function reset() {
    setpageLimit(0);
  }
  // Filter paramater Value manage for API
  const filterManage = () => {
    let filter = "";
    filter = "&$filter=";
    filter += "isSelected eq true";

    filter = FilterContainsInsensitive(filter, "emailId", search.emailAddress);
    filter = FilterContainsInsensitive(filter, "lotNo", search.lotNo);
    filter = FilterContainsInsensitive(
      filter,
      "companyName",
      search.companyName
    );
    filter = FilterEqual(filter, "collectionSeason", search.collectionSeason);
    filter = FilterEqual(filter, "tenderNo", search.tenderNo);
    filter = FilterContainsInsensitive(filter, "socity", search.socity);

    if (filter === "&$filter=") {
      filter = "";
    }
    return filter;
  };
  const getPageCount = async () => {
    if (authenticated) {
      await apiCallResponse(`LotDetails/getLotDetails?${filterManage()}`).then(
        (res) => {
          if (res.success) paggingManage(parseInt(res.data.length) || 0);
          else paggingManage(0, false);
        }
      );
    }
  };
  const getLotDetails = async () => {
    if (authenticated) {
      paggingDisabled();
      setloading(true);
      // header.append();

      await apiCallResponse(
        `LotDetails/getLotDetails?$orderBy=${textField}%20${order}&$skip=${pageLimit}&$top=${parseInt(
          itemPerPage
        )}${filterManage()}`
      )
        .then((res) => {
          if (res.success) {
            setuserData(res.data);
            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          }
          setloading(false);
        })
        .finally();
    }
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };
  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };
  // Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setuserData();
    setSearch({ ...search, ...defaultCommonSearchModel });
  };

  let additional = (
    <CommonSearch
      isDisabledSearchClear={loading}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isDisabledExport={usersData && usersData.length > 0 ? false : true}
      isCompanyNameDisplay={true}
      isEmailAddressDisplay={true}
      isLotNumberDisplay={true}
      extraControl={
        <SCInput
          label={"Society : "}
          name={"socity"}
          value={search.socity}
          onChange={updateSearch}
        />
      }
    />
  );

  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Lot List"
      loading={loading}
      path="/lotlistview/"
      additional={additional}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      tabBtn="View"
      id="lotId"
    />
  );
};
export default LotDetails;
